import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: "card-bg settings-btn card-bg-style-btn",
    id: "card-bg",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleCardStyleBG && _ctx.toggleCardStyleBG(...args)))
  }, _cache[1] || (_cache[1] = [
    _createTextVNode(" Click To "),
    _createElementVNode("span", { class: "white" }, "White", -1),
    _createElementVNode("span", { class: "gray" }, "Gray", -1)
  ])))
}